import { withTiming } from '@common/core/utils/withTiming'

import { sendFeedbackEmail } from '../mailing'
import type { FeedbackPayload } from '../types/feedback-payload.types'

export const submitFeedback = withTiming('submitFeedback', async (payload: FeedbackPayload): Promise<void> => {
  await sendFeedbackEmail(payload)
})
